import { County, LookupDto } from '../../state/lookups/lookups-model';

export const displayValueFn = (status: LookupDto | string): string => {
  if (!status) return '';

  if (typeof status === 'string') return status;

  return status.displayValue || '';
};

export const descriptionValueFn = (status: LookupDto | string): string => {
  if (!status) return '';

  if (typeof status === 'string') return status;

  return status.description || '';
};

export const countyDisplayFn = (county: County | string | null): string => {
  if (!county) return '';
  if (typeof county === 'string') return county;
  return county.countyName || '';
};
